import script from "./SidebarMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./SidebarMenu.vue?vue&type=script&lang=ts&setup=true"

import "./SidebarMenu.vue?vue&type=style&index=0&id=4c0748cc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c0748cc"]])

export default __exports__